// removed by extract-text-webpack-plugin
module.exports = {"container":"_2CDaEuZAaqopo8f6dTXr5M","title":"HtHopuWLbFmFvJ0fndqcx"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/UserInformation/OwnSign/styles.css
// module id = 3164
// module chunks = 0